import Button from '@alltrails/shared/denali/components/Button';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import * as styles from './styles/styles.module.scss';

type Props = {
  handleClick?: () => void;
};

const GiveAllTrailsBanner = ({ handleClick = () => {} }: Props) => (
  <section className={styles.container}>
    <h3 className={styles.header}>
      <FormattedMessage defaultMessage="Give an AllTrails Pro gift subscription" />
    </h3>
    <div className={styles.subText}>
      <FormattedMessage defaultMessage="Help them get the adventure started." />
    </div>
    <Button
      text={<FormattedMessage defaultMessage="Buy gift" />}
      className={styles.button}
      onClick={handleClick}
      testId="gift-at-banner-buy-gift"
      variant="primary"
    />
  </section>
);

export default GiveAllTrailsBanner;
